<template>
  <basic-container>
     <el-tabs v-model="activeName" type="card" @tab-click="tableData=[];searchAct()">
      <el-tab-pane label="线上数据" name="1"></el-tab-pane>
      <el-tab-pane label="本地数据" name="0"></el-tab-pane>
    </el-tabs>
    <div class="search_group">
      <el-input :maxlength="30" v-model="productCode" size="small" placeholder="输入商品编号"></el-input>
      <el-input :maxlength="30" v-model="searchName" size="small" placeholder="输入商品名称"></el-input>
      <el-select @change="searchAct" v-model="productType" filterable clearable size="small" placeholder="会员类型名称">
        <el-option v-for="item in productTypeList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="priceStatus" clearable size="small" placeholder="会员售价状态">
        <el-option label="生效" :value="1"></el-option>
        <el-option label="失效" :value="2"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="isIos" clearable size="small" placeholder="销售渠道">
        <el-option label="非IOS内购" :value="0"></el-option>
        <el-option label="IOS内购" :value="1"></el-option>
      </el-select>
      <el-select v-if="activeName=='0'" @change="searchAct" v-model="checkStatus" clearable size="small" placeholder="审核状态">
        <el-option label="草稿" :value="0"></el-option>
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="通过" :value="2"></el-option>
        <el-option label="不通过" :value="3"></el-option>
      </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
      <el-button v-if="activeName=='0'" v-auth="'memberAuth_add'" @click="openEdit" icon="el-icon-plus" size="small" type="primary">新增</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
      :key="activeName" v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column fixed label="ID" width="200">
        <template slot-scope="scope">{{activeName=='0'?scope.row.originalId:scope.row.id}}</template>
      </el-table-column>
      <el-table-column prop="productCode" label="商品编号" width="200"></el-table-column>
      <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
      <el-table-column prop="sort" label="显示顺序"></el-table-column>
      <el-table-column prop="orderPlacerName" label="前端可见">
        <template slot-scope="scope">{{scope.row.isShow==1?'可见':scope.row.isShow==0?'不可见':''}}</template>
      </el-table-column>
      <el-table-column prop="productTypeName" label="会员类型名称" width="150"></el-table-column>
      <el-table-column prop="shortDesc" label="短描述"></el-table-column>
      <el-table-column prop="mediumDesc" show-overflow-tooltip label="中描述"></el-table-column>
      <el-table-column prop="longDesc" show-overflow-tooltip label="长描述"></el-table-column>
      <el-table-column prop="periodValue" label="定价周期">
        <template slot-scope="scope">{{scope.row.periodValue}}{{scope.row.periodTypeName}}</template>
      </el-table-column>
      <el-table-column prop="originalPrice" label="售价（元）" width="100"></el-table-column>
      <el-table-column label="可购买次数" width="120">
        <template slot-scope="scope">{{scope.row.isOnlyOnce==1?'一次':scope.row.isOnlyOnce==0?'无限次':''}}</template>
      </el-table-column>
      <el-table-column label="销售渠道" width="120">
        <template slot-scope="scope">{{scope.row.isIos==1?'IOS内购':scope.row.isIos==0?'非IOS内购':''}}</template>
      </el-table-column>
      <el-table-column label="会员售价状态" width="120">
        <template slot-scope="scope">{{scope.row.status==1?'生效':scope.row.status==2?'失效':''}}</template>
      </el-table-column>
      <el-table-column v-if="activeName=='0'" label="审核状态">
        <template slot-scope="scope">{{scope.row.reviewStatus | reviewStatus}}</template>
      </el-table-column>
      <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
      <el-table-column v-if="activeName=='0'" fixed="right" width="250" label="操作">
        <template slot-scope="scope">
          <el-button @click="submitCheck(scope.row)" v-if="scope.row.reviewStatus==0||scope.row.reviewStatus==4" v-auth="'memberAuth_submitCheck'" icon="el-icon-info" size="mini" type="text">提交审核</el-button>
          <el-button @click="openCheck(scope.row)" v-if="scope.row.reviewStatus==1" v-auth="'memberAuth_check'" icon="el-icon-info" size="mini" type="text">审核</el-button>
          <el-button @click="changeCheck(scope.row, 4)" v-if="scope.row.reviewStatus==1" v-auth="'memberAuth_cancelCheck'" icon="el-icon-info" size="mini" type="text">撤销审核</el-button>
          <el-button @click="openLog(scope.row)" v-auth="'memberAuth_viewLog'" icon="el-icon-view" size="mini" type="text">查看日志</el-button>
          <el-button v-if="activeName=='0'&&scope.row.reviewStatus!==1" @click="openEdit(scope.row)" v-auth="'memberAuth_change'" icon="el-icon-edit" size="small" type="text">修改</el-button>
          <el-button v-if="activeName=='0'" @click="delProduct(scope.row)" v-auth="'memberAuth_delete'" icon="el-icon-delete" size="small" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <el-dialog title="审核会员售价" top="10%" custom-class="member-approve-popups" :visible.sync="showCheck" append-to-body width="600px">
      <el-form :model="checkItem" size="mini" label-width="110px">
        <el-form-item label="商品编号">{{checkItem.productCode}}</el-form-item>
        <el-form-item label="商品名称">{{checkItem.name}}</el-form-item>
        <el-form-item label="会员类型名称">{{checkItem.productTypeName}}</el-form-item>
        <el-form-item label="短描述">{{checkItem.shortDesc}}</el-form-item>
        <el-form-item label="中描述">{{checkItem.mediumDesc}}</el-form-item>
        <el-form-item label="长描述">{{checkItem.longDesc}}</el-form-item>
        <el-form-item label="定价周期">{{checkItem.periodValue}}{{checkItem.periodTypeName}}</el-form-item>
        <el-form-item label="售价">{{checkItem.originalPrice}}元</el-form-item>
        <el-form-item label="可购买次数">{{checkItem.isOnlyOnce==1?'一次':checkItem.isOnlyOnce==0?'无限次':''}}</el-form-item>
        <el-form-item label="终端可见">{{checkItem.isShow==1?'是':checkItem.isShow==0?'否':''}}</el-form-item>
        <el-form-item label="会员售价状态">{{checkItem.status==1?'生效':checkItem.status==2?'失效':''}}</el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkMark" placeholder="请输入审核意见"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCheck(checkItem, 2)" v-auth="'memberAuth_check'" size="small" type="primary" icon="el-icon-circle-check">同意审核</el-button>
        <el-button @click="changeCheck(checkItem, 3)" v-auth="'memberAuth_check'" size="small" type="danger" icon="el-icon-circle-close">拒绝审核</el-button>
        <el-button @click="showCheck=false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="操作日志" :visible.sync="showLog" append-to-body width="40%">
      <el-table :height="400" border :data="logData">
        <el-table-column prop="applyUserName" label="申请人"></el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="180"></el-table-column>
        <el-table-column prop="operationType" label="操作类型"></el-table-column>
        <el-table-column prop="reviewUserName" label="审核人"></el-table-column>
        <el-table-column prop="reviewContent" show-overflow-tooltip label="审核内容"></el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" width="180"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showLog=false" size="small" type="primary" icon="el-icon-circle-check">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="checkItem.id?'修改会员售价':'新增会员售价'" custom-class="member-form-popups" :visible.sync="showEdit" append-to-body width="600px">
      <div class="member-form__wrap">
        <el-form ref="ruleForm" :rules="rules" :model="checkItem" label-width="110px" size="small">
          <el-form-item label="商品编号" prop="productCode">
            <el-input :maxlength="30" v-model="checkItem.productCode" size="small" placeholder="请输入商品编号"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="name">
            <el-input :maxlength="30" v-model="checkItem.name" size="small" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序" prop="sort">
            <el-input-number v-model="checkItem.sort" size="small" :step="1" :min="1" :max="9999999999"></el-input-number>
          </el-form-item>
          <el-form-item label="会员类型" prop="productType">
            <el-select v-model="checkItem.productType" size="small" placeholder="选择会员类型名称">
              <el-option v-for="item in inUseProdType" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短描述">
            <el-input :maxlength="30" v-model="checkItem.shortDesc" size="small" placeholder="请输入短描述"></el-input>
          </el-form-item>
          <el-form-item label="中描述">
            <el-input :maxlength="50" v-model="checkItem.mediumDesc" size="small" placeholder="请输入中描述"></el-input>
          </el-form-item>
          <el-form-item label="长描述">
            <el-input type="textarea" :rows="3" :maxlength="100" resize="none" v-model="checkItem.longDesc" placeholder="请输入长描述"></el-input>
          </el-form-item>
          <el-form-item label="定价周期" prop="periodValue">
            <el-input placeholder="请输入定价周期" v-model="checkItem.periodValue" class="input-with-select">
              <el-select v-model="checkItem.periodType" slot="append">
                <el-option label="天" :value="1"></el-option>
                <el-option label="月" :value="2"></el-option>
                <el-option label="季" :value="3"></el-option>
                <el-option label="年" :value="4"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="售价" prop="originalPrice">
            <el-input-number v-model="checkItem.originalPrice" size="small" :precision="2" :step="0.1" :min="0.01" :max="9999999999"></el-input-number> 元
          </el-form-item>
          <el-form-item label="销售渠道">
            <el-radio-group v-model="checkItem.isIos">
              <el-radio :label="1">IOS内购</el-radio>
              <el-radio :label="0">非IOS内购</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可购买次数">
            <el-radio-group disabled v-model="checkItem.isOnlyOnce">
              <el-radio :label="0">无限次</el-radio>
              <el-radio :label="1">1次</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="前端可见">
            <el-radio-group v-model="checkItem.isShow">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="会员售价状态">
            <el-radio-group v-model="checkItem.status">
              <el-radio v-model="checkItem.status" :label="1">生效</el-radio>
              <el-radio v-model="checkItem.status" :label="2">失效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkItem.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveEdit('ruleForm')" v-auth="'memberAuth_change'" size="small" type="primary" icon="el-icon-circle-check">保存</el-button>
        <el-button @click="showEdit=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { productList, submitProduct, removeProduct, listProductType, submitExamine, updateExamine, reviewLog } from '@/api/member'
import { validateNonNull } from '@/util/validate'
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],

  computed: {
    inUseProdType() {
      return this.productTypeList.filter(item => item.typeStatus == 1)
    }
  },
  data () {
    var validatePeriod = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入定价周期'));
      } else if (value !== '' && (!/^([1-9]|\d{1,2})$/.test(value))) {
        callback(new Error('定价周期只能是2位数值'));
      } else {
        callback();
      }
    };
    return {
      productTypeList: [], // 会员类型列表
      activeName: '1', // 选择tab
      productCode: '', // 商品编号
      searchName: '', // 商品名称
      productType: '', // 商品类型
      priceStatus: '', // 售价状态
      isIos: '', // 销售渠道
      checkStatus: '', // 审核状态
      checkItem: {
        id: '',
        productCode: '',
        name: '',
        sort: '',
        productType: '',
        shortDesc: '',
        mediumDesc: '',
        longDesc: '',
        periodValue: '',
        periodType: 2,
        isIos: 1,
        isOnlyOnce: 0,
        isShow: 1,
        status: 1,
        remark: ''
      }, // 查看项
      checkMark: '', // 审核意见
      showCheck: false, // 审核弹窗
      logData: [], // 日志列表
      showLog: false, // 操作日志弹窗
      rules: {
        productCode: [{ required: true, trigger: 'blur', validator: validateNonNull }],
        name: [{ required: true, trigger: 'blur', validator: validateNonNull }],
        sort: [{ required: true, message: '请输入显示顺序' , trigger: 'blur' }],
        productType: [{ required: true, message: '请选择会员类型' , trigger: 'change' }],
        periodValue: [{ required: true, validator: validatePeriod, trigger: 'blur' }],
        originalPrice: [{ required: true, message: '请输入售价' , trigger: 'blur' }]
      },
      showEdit: false // 新增/修改弹窗
    }
  },
  mounted () {
    listProductType().then(res => {
      if (res.data.code === 200) {
        this.productTypeList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    this.getList()
  },
  methods: {
    // 打开审核
    openCheck (item) {
      this.checkMark = ''
      this.showCheck = true
      this.checkItem = deepCopy(item)
    },
    // 打开日志
    openLog: debounce(function (item) {
      reviewLog({
        bizCode: 20,
        bizRefrenceId: item.id
      }).then(res => {
        if (res.data.code === 200) {
          this.logData = res.data.data
          this.showLog = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 打开新增或编辑
    openEdit (item) {
      this.showEdit = true
      if (item.id) {
        for (let key of Object.keys(this.checkItem)) {
          this.checkItem[key] = item[key];
        }
      } else {
        for (let key of Object.keys(this.checkItem)) {
          this.checkItem[key] = '';
        }
        this.checkItem.periodType = 2;
        this.checkItem.isIos = 1;
        this.checkItem.isOnlyOnce = 0;
        this.checkItem.isShow = 1;
        this.checkItem.status = 1;
      }
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        isUsed: this.activeName,
        productCode: this.productCode.trim(),
        productType: this.productType,
        name: this.searchName.trim(),
        status: this.priceStatus,
        isIos: this.isIos,
        current: this.pageNo,
        size: this.pageSize
      }
      if (this.activeName === '0') {
        postData.reviewStatus = this.checkStatus
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      productList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 删除
    delProduct (item) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        removeProduct({ ids: item.id }).then(res => {
          if (res.data.code === 200) {
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 保存新增或编辑
    saveEdit: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitProduct(this.checkItem).then(res => {
            if (res.data.code === 200) {
              this.showEdit = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false
        }
      })
    }, 300, false),
    // 提交审核
    submitCheck: debounce(function (item) {
      submitExamine({
        status: 1,
        bizRefrenceId: item.id
      }).then(res => {
        if (res.data.code === 200) {
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 修改审核状态
    changeCheck: debounce(function (item, status) {
      let postData = {
        bizRefrenceId: item.id,
        status: status
      }
      if (status !== 4) {
        if (!this.checkMark && status === 3) {
          this.$message.warning('请输入审核意见')
          return
        }
        postData.content = this.checkMark
      }
      updateExamine(postData).then(res => {
        if (res.data.code === 200) {
          this.showCheck = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false)
  }
}
</script>


<style lang="scss">
.member-approve-popups {
  .el-form-item {
    margin-bottom: 0;

    .el-form-item__label {
      color: #333333;
      font-weight: 700;
    }
  }
}
.member-form-popups {
  .member-form__wrap {
    padding: 0 20px;
    height: 400px;
    overflow: auto;
  }
  .el-dialog__footer {
    border-top: 1px solid #DCDFE6;
  }
  .el-dialog__body {
    padding: 10px 10px 0;
    .el-input .el-select .el-input {
      width: 80px;
    }
  }
}
</style>
